<template>
  <div>
    <CDropdown :caret="false"
               :offset="[0, 4]"
               :add-menu-classes="'styled-dd-menu'"
               class="styled-dd gallery-dd mb-3">
      <template #toggler>
        <CButton block color="secondary" class="font-weight-normal pr-1">
          <div class="d-flex justify-content-between align-items-center">
            <div class="dd-text">
               {{ $gettext('Please select a gallery') }}
            </div>
            <CIcon name="cipCaretDown" class="icon-sel"/>
          </div>
        </CButton>
      </template>
      <template v-for="(item, index) in galleries">
        <CDropdownItem :key="index" :class="{ 'disabled': item.passive }" @click="onClick(item)">
          <div class="d-flex justify-content-between w-100 align-items-center item"
               :class="{'price-list': item.missing_price_list && showMissingPriceList}">
            <div class="name">
              <CIcon size="custom-size" :height="15" :name="item.is_public?'cipFolderBlueStar':'cipFolderBlue'"
                     class="mr-2" style="vertical-align: baseline"/>
              {{ item.name }}
            </div>
            <div class="circle" v-if="!item.passive">
              <CIcon :name="icon" size="custom-size" :height="12"/>
            </div>
          </div>
        </CDropdownItem>
        <template v-for="(item, index) in item.sub">
          <CDropdownItem :key="'sub' + index" @click="onClick(item)">
            <div class="d-flex align-items-center" style="padding:8px">
              <CIcon size="custom-size" :height="16" name="cipCornerDownRight" class="ml-2" style="color:#A9A8C2"/>
            </div>
            <div class="d-flex justify-content-between w-100 align-items-center item"
                 :class="{'price-list': item.missing_price_list && showMissingPriceList}">
              <div class="name">
                <CIcon size="custom-size" :height="15" :name="item.is_public?'cipFolderBlueStar':'cipFolderBlue'"
                       class="mr-2" style="vertical-align: baseline"/>
                {{ item.name }}
              </div>
              <div class="circle">
                <CIcon :name="icon" size="custom-size" :height="12"/>
              </div>
            </div>
          </CDropdownItem>
        </template>
      </template>
    </CDropdown>
  </div>
</template>

<script>
export default {
  name: "GalleriesDropDown",
  emits: ['select'],
  props: {
    galleries: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      default: 'cipUpload2'
    },
    showMissingPriceList: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(gallery) {
      this.$emit('select', gallery);
    }
  }
}
</script>

<style scoped>

</style>